import { Box, TablePagination } from '@mui/material';
import { GridFooterContainer } from '@mui/x-data-grid-pro';

import { Button } from '../v3/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from './table';

export const CustomCursorFooter = props => {
  const {
    currentPage,
    hasNextPage,
    onNextPage,
    onPrevPage,
    loading,
    pageSize,
    onPageSizeChange,
    // Callers pass `rowsPerPageOptions` (the MuiTable prop name); `pageSizeOptions`
    // is kept as an alias so either spelling applies.
    rowsPerPageOptions,
    pageSizeOptions,
    totalRows = -1, // -1 indicates unknown total for cursor pagination
  } = props;

  const pageSizeChoices = rowsPerPageOptions || pageSizeOptions || DEFAULT_ROWS_PER_PAGE_OPTIONS;

  const handlePrevClick = e => {
    e.preventDefault();
    e.stopPropagation();
    console.log('Previous button clicked', {
      currentPage,
      loading,
      onPrevPage: typeof onPrevPage,
      willCallHandler: currentPage > 0 && !loading,
    });
    if (currentPage > 0 && !loading) {
      console.log('Calling onPrevPage...');
      onPrevPage();
    } else {
      console.log('NOT calling onPrevPage - conditions not met');
    }
  };

  const handleNextClick = e => {
    e.preventDefault();
    e.stopPropagation();
    console.log('Next button clicked', {
      hasNextPage,
      loading,
      onNextPage: typeof onNextPage,
      willCallHandler: hasNextPage && !loading,
    });
    if (hasNextPage && !loading) {
      console.log('Calling onNextPage...');
      onNextPage();
    } else {
      console.log('NOT calling onNextPage - conditions not met');
    }
  };

  return (
    <GridFooterContainer>
      {/* Spacer */}
      <Box sx={{ flex: 1 }} />

      {/* MUI TablePagination with custom actions */}
      <TablePagination
        component="div"
        count={totalRows}
        page={currentPage}
        onPageChange={() => {}} // Not used with custom actions
        rowsPerPage={pageSize}
        onRowsPerPageChange={e => onPageSizeChange(Number(e.target.value))}
        rowsPerPageOptions={pageSizeChoices}
        // This footer is also used inside the v3 Sheet overlays, and a modal
        // Radix dialog sets `pointer-events: none` on the body while it is open —
        // a menu portaled to the body is then unclickable, and a click on it
        // counts as an outside interaction that closes the sheet. Rendering the
        // menu in place keeps it inside the sheet's own subtree.
        SelectProps={{ MenuProps: { disablePortal: true } }}
        labelDisplayedRows={({ page }) => `Page ${page + 1}`}
        ActionsComponent={() => (
          <Box sx={{ display: 'flex', gap: 1, ml: 2 }}>
            <Button
              className="!h-[22px] !w-[31px] !px-0 bg-[#194bfb] hover:bg-[#000fff]"
              variant="default"
              size="icon"
              onClick={handlePrevClick}
              disabled={currentPage === 0 || loading}
              type="button">
              <ChevronLeft size={16} className="!h-5 !w-5 mr-[2px]" />
            </Button>

            <Button
              variant="default"
              size="icon"
              className="!h-[22px] !w-[31px] !px-0 bg-[#194bfb] hover:bg-[#000fff]"
              onClick={handleNextClick}
              disabled={!hasNextPage || loading}
              type="button">
              <ChevronRight size={16} className="!h-5 !w-5 ml-[2px]" />
            </Button>
          </Box>
        )}
      />
    </GridFooterContainer>
  );
};
